
      import VideoLine from './video-line.vue'
      import type { App, Plugin } from 'vue'

      export const VideoLinePlugin: Plugin = {
        install(app: App) {
          app.component('VideoLine', VideoLine)
        },
      }
      export { VideoLine }
      